import { inject, Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { TReducerState } from '../../app.config';

export enum ETranslatableEntity {
  product = 'products',
  tasks = 'tasks',
  activities = 'activities',
  equipmentList = 'equipment_list',
}

export interface IEntityTranslation {
  entityId?: number;
  entityName?: ETranslatableEntity;
  language: string;
  propertyName: string;
  value: string;
}

@Injectable({
  providedIn: 'root',
})
export class EntityTranslatorService {
  private readonly globalStore = inject<Store<TReducerState>>(Store<TReducerState>);
  private language = this.globalStore.selectSignal(({ user }) => user.user!.dfUserConfiguration.language);

  public findTranslatedValue(
    entityTranslations: IEntityTranslation[],
    entityName: ETranslatableEntity,
    propertyName: string,
    id: number,
    defaultValue: string,
    language: string = this.language(),
  ): string {
    if (!language || !entityTranslations?.length || language === 'en') {
      return defaultValue;
    }

    const translation = entityTranslations.find(
      (entityTranslation: IEntityTranslation) =>
        entityTranslation.entityName === entityName &&
        entityTranslation.entityId === id &&
        entityTranslation.propertyName === propertyName &&
        (!language || entityTranslation.language === language),
    );

    return translation?.value ?? defaultValue;
  }
}
